/* eslint react/forbid-prop-types:0 */

import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  separator: {
    borderBottom: '#dedede 1px solid',
    margin: '5px auto',
    width: '110px',
  },
};

export default function Separator({ css }) {
  const separatorStyles = Object.assign({}, styles.separator, css);
  return <div style={separatorStyles} />;
}

Separator.propTypes = {
  css: PropTypes.object,
};

Separator.defaultProps = {
  css: {},
};
